<!-- 商品操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <!-- 商品信息 -->
                            <div v-if="scope.index == 0">
                                <el-form label-width="140px" label-position="right" size="mini" ref="dynamicValidateForm" class="baseForm" :model="sendDataInfoObj" :show-message="false">
                                    <el-row>
                                        <el-form-item label="申请部门" prop="cmCode">
                                            <label slot="label" :style="$common.labelStyle('申请部门')" v-html="$common.htmlLabel('申请部门')"></label>
                                            <el-input disabled v-model="sendDataInfoObj.depName"></el-input>
                                        </el-form-item>
                                        <el-form-item label="申请人" prop="cmCode">
                                            <label slot="label" :style="$common.labelStyle('申请人')" v-html="$common.htmlLabel('申请人')"></label>
                                            <el-input clearable disabled v-model="sendDataInfoObj.opmName"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row>
                                        <el-form-item label="申请原因" prop="applyReason" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                            <label slot="label" :style="$common.labelStyle('申请原因')" v-html="$common.htmlLabel('申请原因')"></label>
                                            <el-input clearable type="textarea" :rows="2" v-model="sendDataInfoObj.applyReason"></el-input>
                                        </el-form-item>
                                        <el-form-item label="修改备注" prop="remark">
                                            <label slot="label" :style="$common.labelStyle('修改备注')" v-html="$common.htmlLabel('修改备注')"></label>
                                            <el-input clearable type="textarea" rows="2" v-model="sendDataInfoObj.remark"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-form-item v-if="dataActionBox.actionType == 0 || dataActionBox.actionType == 3">
                                        <el-button type="primary" @click="openSearch(813183934369792, 0, 'bgmName', 'bgmId,bgmName')">提取商品</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-divider content-position="left">
                                    <h4>{{ isQixie === 1 ? '器械' : isQixie === 2 ? '其他' : '药品' }}信息</h4>
                                </el-divider>
                                <el-form label-width="120px" class="baseForm" size="mini" :model="sendDataInfo" ref="sendDataInfo" :show-message="false">
                                    <el-row>
                                        <el-form-item v-if="formOneValue.isShow == 1" :label="formOneValue.showField" :id="formOneValue.entityField" :prop="formOneValue.entityField"
                                            v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []"
                                            :hide-required-asterisk="formOneValue.isRequired == 1 ? true : false">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                            <template>
                                                <el-tooltip class="item"
                                                    :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' || sendDataInfo[formOneValue.entityField].length <= 9 ? true : false"
                                                    effect="dark" :content="getValue(sendDataInfo[formOneValue.entityField], formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)" placement="bottom-start">
                                                    <!-- 库房 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" filterable v-if="formOneValue.entityField == 'stId'" v-model="sendDataInfo[formOneValue.entityField]" clearable>
                                                        <el-option v-for="(storageRoomValue, storageRoomKey) in storageRoomList" :key="storageRoomKey" :label="storageRoomValue.stName" :value="storageRoomValue.stId">
                                                        </el-option>
                                                    </el-select>
                                                    <el-input v-else-if="formOneValue.entityField == 'bgmName'" clearable v-model="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isUpdate == 0"></el-input>
                                                    <el-input v-else-if="formOneValue.fieldType == 'search'" clearable @clear="clear(formOneValue.setField)" v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                        :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                        :disabled="formOneValue.isUpdate == 0">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                            :disabled="formOneValue.isUpdate == 0">
                                                        </el-button>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'ggmInitunit'" clearable :disabled="formOneValue.isUpdate == 0" v-model.trim="sendDataInfo.ggmInitunitName"
                                                        @focus="openSearch(formOneValue.searchId, 0, 'ggmInitunit')">
                                                    </el-input>
                                                    <!-- 备注 -->
                                                    <el-input :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgmRemarks'" type="textarea" clearable
                                                        v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>

                                                    <!-- 长 -->
                                                    <el-input :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgpMinilength'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>

                                                    <!-- 宽 -->
                                                    <el-input :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgpMiniwidth'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>

                                                    <!-- 高 -->
                                                    <el-input :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgpMiniheight'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">厘米（cm）</template>
                                                    </el-input>

                                                    <!-- 体积 -->
                                                    <el-input :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgpMinivolume'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">立方厘米（cm3）</template>
                                                    </el-input>
                                                    <!-- 重量 -->
                                                    <el-input :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgpMiniweight'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0">
                                                        <template slot="append">克（g）</template>
                                                    </el-input>
                                                    <!-- 包装单位 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" filterable clearable v-else-if="formOneValue.entityField == 'bgpUnitmeasurement'" v-model="sendDataInfo[formOneValue.entityField]"
                                                        style="width: 100%;">
                                                        <el-option v-for="(values) in dictionariesData.BZDW" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                    </el-select>
                                                    <!-- 大包装 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" filterable clearable v-else-if="formOneValue.entityField == 'largePackage'" v-model="sendDataInfo[formOneValue.entityField]"
                                                        style="width: 100%;">
                                                        <el-option v-for="(values) in dictionariesData.DBZ" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                                                    </el-select>
                                                    <!-- 装箱规格 -->
                                                    <el-input :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'packingSpec'" @blur="number($event)" v-model.number="sendDataInfo[formOneValue.entityField]"
                                                        type="number" min="0" @keydown.up.native="increase" @keydown.down.native="decrease">
                                                    </el-input>

                                                    <!-- 编号分类 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'codeType'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in codeClassify" :key="dictionariesKey" :label="dictionariesValue.codeType" :value="dictionariesValue.codeType">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 养护类型 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'bgiCurtype'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.yhlx" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 剂型 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'bgiDromodel'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue) in dictionariesData.jx" :key="dictionariesValue.diValue" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 处方类型 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'bgiPretype'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.cflx" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 质量标准 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'bgiQuatype'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.zlbz" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 存储类型 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'bgiStocondition'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.cctj" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 运输类型 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'transMode'" filterable v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.YSLX" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 生产范围 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'bgiProrange'" filterable v-model="sendDataInfo[formOneValue.entityField]"
                                                        style="width: 100%;">
                                                        <el-option v-for="(values) in rangeObj.p" :key="values.discId" :label="values.scopeName" :value="String(values.discId)">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 经营范围 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'bgiManrange'" filterable v-model="sendDataInfo[formOneValue.entityField]"
                                                        style="width: 100%;">
                                                        <el-option v-for="(values) in rangeObj.m" :key="values.discId" :label="values.scopeName" :value="String(values.discId)">
                                                        </el-option>
                                                    </el-select>

                                                    <!-- 诊疗范围 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'bgiTrerange'" filterable v-model="sendDataInfo[formOneValue.entityField]"
                                                        style="width: 100%;">
                                                        <el-option v-for="(values) in rangeObj.z" :key="values.discId" :label="values.scopeName" :value="String(values.discId)">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 集采分类 -->
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable v-else-if="formOneValue.entityField == 'collectClassify'" filterable v-model="sendDataInfo[formOneValue.entityField]"
                                                        style="width: 100%;">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.CJFL" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 商品分类 -->
                                                    <df-date v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" :isdisabled="formOneValue.isUpdate == 0">
                                                    </df-date>

                                                    <!-- 是否冷藏 -->
                                                    <el-radio-group :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgiIscoldstorage'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>

                                                    <!-- 是否双人验收 -->
                                                    <el-radio-group :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgiIsdcheck'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>

                                                    <!-- 是否双人复核 -->
                                                    <el-radio-group :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgiIsdreview'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>

                                                    <!-- 是否电子监管码 -->
                                                    <el-radio-group :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgiIsesupervise'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>

                                                    <!-- 税务分类名称 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'taxname'" filterable v-model="sendDataInfo[formOneValue.entityField]" @change="taxChange"
                                                        :disabled="formOneValue.isUpdate == 0">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.swflmc" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 财务分类名称 -->
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'financialName'" filterable v-model="sendDataInfo[formOneValue.entityField]" @change="cwflChange"
                                                        :disabled="formOneValue.isUpdate == 0">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.cwfl" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                            :value="dictionariesValue.diValue"></el-option>
                                                    </el-select>
                                                    <el-input v-else-if="formOneValue.entityField == 'suggestedPrice'" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                                        :disabled="formOneValue.isUpdate == 0" @input="validateInput('suggestedPrice')"></el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'lowestPrice'" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                                                        :disabled="formOneValue.isUpdate == 0" @input="validateInput('lowestPrice')"></el-input>

                                                    <el-input :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'validPeriod'" v-model="sendDataInfo[formOneValue.entityField]" type="number" min="0"
                                                        @input="numInput(formOneValue.entityField)">
                                                        <template slot="append">个月</template>
                                                    </el-input>
                                                    <el-input :disabled="formOneValue.isUpdate == 0" v-else-if="formOneValue.entityField == 'bgiMainfunction'" type="textarea" :maxlength="$store.state.inputLength"
                                                        v-model.trim="sendDataInfo[formOneValue.entityField]">
                                                    </el-input>
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable size="mini" filterable v-else-if="formOneValue.entityField == 'bgiType'" @change="changesmIntype"
                                                        v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value"></el-option>
                                                    </el-select>
                                                    <el-select clearable v-else-if="formOneValue.entityField == 'dlType'" filterable v-model="sendDataInfo[formOneValue.entityField]" @change="cwflChange"
                                                        :disabled="formOneValue.isUpdate == 0">
                                                        <el-option v-for="(dictionariesValue, dictionariesKey) in dictionariesData.DLLX" :key="dictionariesKey" :label="dictionariesValue.diName"
                                                            :value="dictionariesValue.diValue"></el-option>
                                                    </el-select>
                                                    <el-select :disabled="formOneValue.isUpdate == 0" clearable size="mini" filterable v-else-if="formOneValue.fieldType == 'formatter'"
                                                        @change="((val) => { handleChange(val, formOneValue.entityField) })" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value"></el-option>
                                                    </el-select>
                                                    <el-input :disabled="formOneValue.isUpdate == 0" clearable v-model.trim="sendDataInfo[formOneValue.entityField]" @blur="blurChange(formOneValue.entityField)"></el-input>
                                                </el-tooltip>
                                            </template>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                            <div v-if="scope.index == 1">
                                <!-- 证照表格 -->
                                <el-form class="baseForm" :inline="true" size="mini">
                                    <div id="operateBtn">
                                        <el-checkbox-group v-model="zzList" style="display: flex;align-items: center;flex-wrap: wrap;">
                                            <div v-for="(item, index) in licenseList" :key="index" style="width: 250px;padding-left: 15px;position: relative;">
                                                <span v-if="item.isBT == 1" style="color:red;" class="xing">*</span>
                                                <span v-if="item.isKX == 1" style="color:#409EFF;" class="xing">*</span>
                                                <el-checkbox style="width: 220px;" :label="item.diName"></el-checkbox>
                                            </div>
                                        </el-checkbox-group>
                                    </div>
                                    <el-table id="mxTable" :data="sendDataInfo.newGoodLicenceAddList" border style="width: 100%" size='mini' :height="mxHeight">
                                        <el-table-column align="center" v-if="formOneValue.isShow == 1" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                            :show-overflow-tooltip="formOneValue.entityField == 'glUrl' ? false : true" :min-width="dealMinWidth(formOneValue.entityField)" :fixed="formOneValue.entityField == 'glUrl' ? 'right' : false">
                                            <template slot="header">
                                                <div>
                                                    <el-tooltip :content="formOneValue.showField" placement="top">
                                                        <div class="long_title"><span>{{ formOneValue.showField
																}}</span>
                                                        </div>
                                                    </el-tooltip>
                                                </div>
                                            </template>
                                            <template slot-scope="scope">
                                                <div>
                                                    <div v-if="formOneValue.isReserved == 1">
                                                        <ul v-if="formOneValue.entityField == 'glUrl'" class="uploadList">
                                                            <li v-for="(val, key) in scope.row.uploadVoList" :key="key" class="image">
                                                                <i class="el-icon-error del" @click="delRemove(scope.$index, key)"></i>
                                                                <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="val.url" :preview-src-list="scope.row.uploadVoList.map(item => item.url)">
                                                                </cusImage>
                                                            </li>
                                                        </ul>
                                                        <df-date :isType="true" v-else-if="formOneValue.entityField == 'glTervalidity'" v-model="sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]"
                                                            :isdisabled="formOneValue.isUpdate == 0">
                                                        </df-date>
                                                        <df-date :isType="true" :isShowLong="false" v-else-if="formOneValue.entityField == 'glRedate'" v-model="sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]"
                                                            :isdisabled="formOneValue.isUpdate == 0">
                                                        </df-date>
                                                        <df-date :isType="true" v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]"
                                                            :isdisabled="formOneValue.isUpdate == 0"></df-date>
                                                        <!-- 证照类型 -->
                                                        <span v-else-if="formOneValue.entityField == 'lityId'">
                                                            {{
																sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]
															}}
                                                        </span>
                                                        <el-radio-group v-else-if="formOneValue.entityField == 'isUsed'" :disabled="formOneValue.isUpdate == 0"
                                                            v-model="sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]">
                                                            <el-radio-button label="0">否</el-radio-button>
                                                            <el-radio-button label="1">是</el-radio-button>
                                                        </el-radio-group>
                                                        <!-- 是否拦截 -->
                                                        <el-radio-group v-else-if="formOneValue.entityField == 'isIntercept'" :disabled="formOneValue.isUpdate == 0"
                                                            v-model="sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]">
                                                            <el-radio-button label="0">否</el-radio-button>
                                                            <el-radio-button label="1">是</el-radio-button>
                                                        </el-radio-group>

                                                        <!-- 备注 -->

                                                        <el-input v-else-if="formOneValue.entityField == 'glTernumber'" v-model.trim="sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]"
                                                            :maxlength="$store.state.inputLength">
                                                            <template slot="append"><span style="color: red;">{{
																sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]
																	== '' ||
																	sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]
																	== null ||
																	sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]
																	== undefined ? 0 :
																	sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField].length
															}}位</span></template>
                                                        </el-input>
                                                        <el-input v-else v-model.trim="sendDataInfo.newGoodLicenceAddList[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    </div>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" :width="printScanShow?380:300">
                                            <template slot-scope="scope">
                                                <input style="display: none;" type="file" id="recordExcel" accept="image/*" multiple name="recordExcel" @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                                                <label for="recordExcel" class="image_label" @click="eventIndex = scope.$index">上传</label>
                                                <el-button type="primary" @click="showUploadDialog(scope.$index)">拖拽上传</el-button>
                                                <el-button @click.stop="openFile1(0), eventIndex = scope.$index" type="primary" size="mini">高拍仪</el-button>
                                                <el-button v-if="printScanShow" @click.stop="openFile1(1), eventIndex = scope.$index" type="primary" size="mini">扫描仪</el-button>
                                                <el-button @click="deleteDetails(scope.row)" type="danger" size="mini">删除</el-button>
                                                <el-button type="primary" size="mini" @click="copyClick(scope.row)">复制</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <div>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0 || dataActionBox.actionType == 3">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="instrumentFlag" :visible.sync="instrumentFlag" width="70%" :modal-append-to-body='true' :append-to-body="true" top="20px">
            <bgiRegistnoAction v-if="seType == 'bgiRegistno'" ref="bgiRegistnoAction" @TranData="bgiBrandClick">
            </bgiRegistnoAction>
            <bgiBrandAction v-else-if="seType == 'bgiBrand'" ref="bgiBrandAction" @TranData="bgiBrandClick">
            </bgiBrandAction>
        </el-dialog>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true" :before-close="showClose">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showClose">确 定</el-button>
            </span>
        </el-dialog>
        <FileNewAction ref="FileNewAction" v-if="showFile" :showFile="showFile" uploadType="zz" @isshowFile="IsshowFile" @NewelectFileIds="changeFileIds"></FileNewAction>
        <!-- 扫描仪 -->
        <el-dialog title="扫描仪上传" destroy-on-close :visible.sync="scanShow" width="80%" append-to-body top="20px">
            <scannerPlugin v-if="scanShow" ref="scannerPlugin" uploadType="zz" @submit="scanOnSubmit"></scannerPlugin>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog title="批量打印" :visible.sync="diaImgs" width="900px" :modal-append-to-body="true" :append-to-body="true">
            <el-button type="primary" v-print="'#imgs'" size="mini" style="margin-bottom:10px">打印</el-button>
            <div id="imgs" style="width: 800px;">
                <div v-for="(key, index) in fileData" :key="index" style="height: 1100px;width: 800px; position: relative; ">
                    <el-image v-if="key.flag" :style="`width: 1100px;height: 800px;transform: rotateZ(90deg);position: absolute;left:-148px;bottom:148px;
 `" :src="key.fileUrl" fit="contain"></el-image>
                    <el-image v-else :style="`width: 800px;height: 1100px; 
 `" :src="key.fileUrl" fit="contain"></el-image>
                    <div style="page-break-after: always;"></div>
                </div>
            </div>
        </el-dialog>
        <ImageViewer v-if="showImgViewer" :url-list="imgPreviewUrl" :on-close="() => { showImgViewer = false }" :z-index="3000" />
        <DragUpload ref="dragUpload" title="文件上传" :multiple="true" :limit="100" uploadType="zz" @confirm="onUploadConfirm" />
    </div>
</template>

<script>
import print from 'vue-print-nb'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "@/byComponents/SearchScheme.vue";
import ImageViewer from 'element-ui/packages/image/src/image-viewer'
import bgiRegistnoAction from "@/components/bgiRegistnoAction.vue";
import bgiBrandAction from "@/components/bgiBrandAction.vue";
import {
    upFile,
} from "@/service/printApi.js";
import axios from 'axios'
import NP from "number-precision";
export default {
    name: "goodsFrom",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ImageViewer,
        bgiRegistnoAction,
        bgiBrandAction,
    },
    data() {
        //这里存放数据
        return {
            showImgViewer: false,
            imgPreviewUrl: [], // 当前要放大的图片存放位置
            diaContract: false, //合同
            showFile: false,
            token: {
                token: sessionStorage.getItem("token"),
            },
            dataActionBoxdigion: false,
            requesUrl: "",
            imgUrl: "",
            fileData: [],
            // 审核信息
            taskData: {
                auditState: 0,
                auditRemark: "",
                businessId: "",
            },
            reviewNodeList: [],
            selectDataTable: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            rulesList: [],
            formKey: 2,
            sendDataInfoObj: {
                businessId: "",//对应的客户Id
                gchmType: 0,
                depName: "",
                depId: "",
                opmName: "",
                opmId: "",
                remark: "",
                applyReason: "",
            },
            sendDataInfo: {},
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            licenseList: [],
            userOneList: [],
            goodsList: [],
            storageRoomList: [],
            swArr: [],
            midPriceData: [
                {
                    priceType: false,
                    levleDiscount: 0,
                    levlePrice: 0,
                    levleId: 0,
                    levleName: "",
                    bgcId: 0,
                },
            ],
            selectedDetailsIndex: 0, //选择索引
            dialogVisible: false,
            dialogImageUrl: "",
            addpushlist: {
                glTername: "", //证照名称
                glTernumber: "",
                glReoffice: "",
                glTervalidity: "",
                glRedate: "",
                uploadVoList: [], //附件
                lityId: "",
                isIntercept: "1",
                isUsed: "1",
                remark: "", //备注
            },
            fileList: [],
            uploadVoList: [],
            fileIdlist: [],
            seTitle: "",
            seWidth: "",
            exWidth: "",
            seType: "",
            DialogVisible: false,
            parentSearchData: {},
            rangeObj: {}, //范围对象
            componentType: false, //判断父级false首营,true业务商品
            mxHeight: 0, //表格动态高度
            isLoaded: false,
            tabForm: [],
            mxForm: [],
            footForm: [],
            sField: "",
            isQixie: 0, //goodType  //药品类型0.药品1.器械2.其他
            view1_mode_list: [],
            view1_resolution_list: [],
            img_base64List: [],
            view1_mode_selected: '1',
            view1_resolution_selected: '',
            selectFileIds: [],
            type: 1,
            watchZZInfo: true,
            dialogList: [],
            showDialog: false,
            showStatus: -1,
            message: "",//提示语
            codeClassify: '',//编号分类
            fileData: [],
            diaImgs: false,
            zzList: [],
            print: {
                id: 'imgs',
                popTitle: 'erp', // 打印配置页上方的标题
                extraHead: 'erp', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
                preview: true, // 是否启动预览模式，默认是false
                previewTitle: 'erp', // 打印预览的标题
                previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
                zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
                previewBeforeOpenCallback() { console.log('正在加载预览窗口！'); console.log(that.msg, this) }, // 预览窗口打开之前的callback
                previewOpenCallback() { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
                beforeOpenCallback() { console.log('开始打印之前！') }, // 开始打印之前的callback
                openCallback() { console.log('执行打印了！') }, // 调用打印时的callback
                closeCallback() { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
                clickMounted() { console.log('点击v-print绑定的按钮了！') },
                standard: '',
                extarCss: '',
            },
            ruleData: [],
            //--------------
            instrumentFlag: false,
            //---------扫描仪上传
            scanShow: false,
            printScanShow: false,
        };
    },
    directives: {
        print
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.bgmName": {
            handler: function (newValue, oldValue) {
                // this.sendDataInfo.mne = this.$common.createPinyinCode(newValue,this.sendDataInfo.mne);
                if (newValue == "") {
                    this.sendDataInfo.barcode = "";
                    this.sendDataInfo.spec = "";
                    this.sendDataInfo.manufacturer = "";
                    this.sendDataInfo.placeorigin = "";
                    this.sendDataInfo.bgiAppnumber = "";
                    this.sendDataInfo.bgiPerholder = "";
                    this.sendDataInfo.bgiProlicense = "";
                    this.sendDataInfo.storageMode = "";
                    this.sendDataInfo.bgpUnitmeasurement = "";
                    this.sendDataInfo.packingSpec = "";
                }
                this.productVerify()
            },
            deep: true,
        },
        "sendDataInfo.spec": {
            handler: function (newValue, oldValue) {
                this.productVerify()
            },
            deep: true
        },
        "sendDataInfo.manufacturer": {
            handler: function (newValue, oldValue) {
                this.productVerify()
            },
            deep: true
        },
        "addpushlist.glTervalidity": {
            handler: function (newValue, oldValue) {
                if (this.watchZZInfo) {
                    this.$nextTick(() => {
                        if (newValue == '' || newValue == 0.5) {
                            return
                        }
                        let data = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
                        if (newValue <= data) {
                            if (newValue.length < 4) {
                                this.addpushlist.glTervalidity = ''
                            } else {
                                this.$confirm('确定要使用吗？有效期已过！', '警告', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'error'
                                }).then(() => {

                                }).catch(() => {
                                    this.addpushlist.glTervalidity = ''

                                });
                            }

                        }
                        if (newValue > data && (data + 30 * 24 * 60 * 60 * 1000) > newValue) {
                            this.$confirm('确定要使用吗？剩余有效期30天以内！', '提醒', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {

                            }).catch(() => {
                                this.addpushlist.glTervalidity = ''
                            });
                        }
                    })
                } else {
                    this.watchZZInfo = true
                }
            },
            deep: true,
        },
        "sendDataInfo.spec": {
            handler: function (newValue, oldValue) {
                this.isQixie
            },
            deep: true
        },
        zzList: {
            deep: true,
            handler(nvl, ovl) {
                let arr = [...nvl]
                this.sendDataInfo.newGoodLicenceAddList = this.sendDataInfo.newGoodLicenceAddList.filter(item => {
                    if (nvl.includes(item.lityId)) {
                        arr.splice(arr.findIndex(items => items == item.lityId), 1)
                        return true
                    } else {
                        return false
                    }
                })
                this.sendDataInfo.newGoodLicenceAddList.forEach((item, index) => {
                    if (item.uploadVoList.length > 0) {
                        item.uploadVoList.map(items => {
                            items.url = this.imgUrl + "/" + items.fileUrl
                            items.name = items.fileName
                            return items
                        })
                    }
                })
                this.sendDataInfo.descibGoodLicenceAddList.forEach((item, index) => {
                    if (item.uploadVoList.length > 0) {
                        item.uploadVoList.map(items => {
                            items.url = this.imgUrl + "/" + items.fileUrl
                            items.name = items.fileName
                            return items
                        })
                    }
                })
                this.$nextTick(() => {
                    arr.forEach(item => {
                        this.sendDataInfo.newGoodLicenceAddList.push({
                            glTername: item, //证照名称
                            sliTername: "",
                            glTernumber: "",
                            glReoffice: "",
                            glTervalidity: "",
                            glRedate: "",
                            uploadVoList: [], //附件
                            lityId: item,
                            isIntercept: "1",
                            isUsed: "1",
                            remark: "", //备注
                        })
                        var index = this.sendDataInfo.newGoodLicenceAddList.length - 1
                        this.lityChange(item, index)
                    })
                })

            }
        },
        "sendDataInfo.newGoodLicenceAddList": {
            handler: function (newValue, oldValue) {
                newValue.forEach(item => {
                    if (item.glRedate && item.glRedate != 0.5 && item.glTervalidity && item.glTervalidity != 0.5 && item.glTervalidity < item.glRedate) {
                        this.$message.error("有效期不能小于办证日期")
                        item.glTervalidity = 0.5
                    }
                })
            },
            deep: true
        }
    },
    //方法集合
    methods: {
        showUploadDialog(index) {
            this.eventIndex = index
            this.$refs.dragUpload.open();
        },
        onUploadConfirm(files) {
            console.log('上传的文件:', files);
            files.forEach(item => {
                this.sendDataInfo.newGoodLicenceAddList[this.eventIndex].uploadVoList.push({
                    fileUrl: item.fileUrl,
                    url: this.imgUrl + "/" + item.fileUrl,
                    fileName: item.fileName,
                    fileId: item.fileId,
                    fileType: this.sendDataInfo.newGoodLicenceAddList[this.eventIndex].lityId,
                })
            })
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'stId') {
                if (this.storageRoomList) {
                    this.storageRoomList.forEach(item => {
                        if (item.stId == val) {
                            str = item.stName
                        }
                    })
                }
            } else if (type == 'dlType') {
                if (this.dictionariesData.DLLX) {
                    this.dictionariesData.DLLX.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgpUnitmeasurement') {
                if (this.dictionariesData.BZDW) {
                    this.dictionariesData.BZDW.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'largePackage') {
                if (this.dictionariesData.DBZ) {
                    this.dictionariesData.DBZ.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiCurtype') {
                if (this.dictionariesData.yhlx) {
                    this.dictionariesData.yhlx.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'collectClassify') {
                if (this.dictionariesData.CJFL) {
                    this.dictionariesData.CJFL.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiDromodel') {
                if (this.dictionariesData.jx) {
                    this.dictionariesData.jx.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiPretype') {
                if (this.dictionariesData.cflx) {
                    this.dictionariesData.cflx.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiQuatype') {
                if (this.dictionariesData.zlbz) {
                    this.dictionariesData.zlbz.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiStocondition') {
                if (this.dictionariesData.cctj) {
                    this.dictionariesData.cctj.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'transMode') {
                if (this.dictionariesData.YSLX) {
                    this.dictionariesData.YSLX.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiProrange') {
                if (this.rangeObj.p) {
                    this.rangeObj.p.forEach(item => {
                        if (item.discId == val) {
                            str = item.scopeName
                        }
                    })
                }
            } else if (type == 'bgiManrange') {
                if (this.rangeObj.m) {
                    this.rangeObj.m.forEach(item => {
                        if (item.discId == val) {
                            str = item.scopeName
                        }
                    })
                }
            } else if (type == 'bgiTrerange') {
                if (this.rangeObj.z) {
                    this.rangeObj.z.forEach(item => {
                        if (item.discId == val) {
                            str = item.scopeName
                        }
                    })
                }
            } else if (type == 'financialName') {
                if (this.dictionariesData.cwfl) {
                    this.dictionariesData.cwfl.forEach(item => {
                        if (item.diValue == val) {
                            str = item.diName
                        }
                    })
                }
            } else if (type == 'bgiType' || fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        dealMinWidth(field) {
            if (field == 'glReoffice' || field == 'glTervalidity' || field == 'glRedate' || field == 'glTernumber' || field == 'glTername' || field == 'lityId') {
                return '200'
            } else if (field == 'glUrl') {
                return '230'
            } else {
                return '100'
            }
        },
        increase(event) {
            // 阻止默认行为
            event.preventDefault();
        },
        decrease(event) {
            event.preventDefault();
        },
        numInput(entityField) {
            console.log(this.sendDataInfo[entityField]);
            var str = JSON.parse(JSON.stringify(this.sendDataInfo[entityField]))
            var arr = str.split("")
            const regex = /^\d+(\.\d+)?$/;
            if (!regex.test(str)) {
                arr.forEach((item, index) => {
                    if (!regex.test(str[index]) && item != ".") {
                        arr.splice(index, 1)
                    }
                })
            }
            var strText = ""
            arr.forEach(item => {
                strText = strText + item
            })
            this.sendDataInfo[entityField] = strText
        },
        //可输入(小数或整数)
        validateInput(entityField) {
            // 正则表达式匹配整数或小数
            const regex = /^\d+(\.\d+)?$/;
            // 检查输入值是否匹配正则表达式
            if (!regex.test(this.sendDataInfo[entityField])) {
                // 如果不匹配，则替换掉非法字符，只保留数字和小数点
                this.sendDataInfo[entityField] = this.sendDataInfo[entityField].replace(/[^\d.]/g, '');
                // 如果需要，可以在这里添加逻辑来定位光标到最后一个合法字符之后
            } else {
            }
            if (String(this.sendDataInfo[entityField]).indexOf(".") != -1) {
                var strNum = String(this.sendDataInfo[entityField]).indexOf(".")
                if (String(this.sendDataInfo[entityField]).length - 1 - strNum > 10) {
                    this.sendDataInfo[entityField] = this.$common.getDecimalInfo(2, this.sendDataInfo[entityField])
                }
            }
        },
        judge(val) {
            if (this.diaImgs) {
                this.$nextTick(() => {
                    console.log(val, document.documentElement.querySelector(`.${val}`));
                })
            }
            // console.log(document.documentElement.querySelector(`.${val}`).querySelector('el-image__inner').clientHeight,
            // document.documentElement.querySelector(`.${val}`).querySelector('el-image__inner').clientWidth,);
            return true
        },
        confirmPrintImgs() {
            this.$print(document.getElementById('imgs'))
        },
        printImgs() {
            this.diaImgs = true
        },
        print() {
            this.$print(document.getElementById('prr'))
        },
        printImg(list) {
            let printArr = []
            list.forEach(item => {
                item.uploadVoList.forEach(e => {
                    if (e.fileUrl != '' && e.fileUrl) {
                        printArr.push(window.global_config.BASE_IMG_URL + '/' + e.fileUrl)
                    }
                })
            })
            this.fileData = []
            printArr.forEach(url => {
                let item = {
                    flag: "",
                    fileUrl: url
                }
                const img = new Image();
                img.src = url
                img.onload = () => {
                    console.log(img.src);
                    console.log(img.width);
                    console.log(img.height);
                    if (img.width > img.height) {
                        item.flag = true
                    } else {
                        item.flag = false
                    }
                    this.fileData.push(item)
                };

            })

            this.diaImgs = true
            //this.$common.batchPrintImage(printArr)
        },
        //商品验证
        productVerify() {
            var bgmName = this.sendDataInfo.bgmName.replace(/\s/g, "")
            var spec = this.sendDataInfo.spec.replace(/\s/g, "")
            var manufacturer = this.sendDataInfo.manufacturer.replace(/\s/g, "")
            if (spec != "" && bgmName != "" && manufacturer != "") {
                this.verify()
            }
        },
        async verify() {
            const params = {
                "bgmId": "",
                "manufacturer": "",
                "name": "",
                "spec": ""
            }
            for (const key in params) {
                if (key == 'name') {
                    params[key] = this.sendDataInfo.bgmName
                } else if (this.sendDataInfo[key]) {
                    params[key] = this.sendDataInfo[key]
                } else {
                    params[key] = ""
                }
            }
            const responseData = await this.$http.GSPgoodscheckRepeatGoods(params)
            if (responseData.status == 300) {
                this.message = responseData.message
            } else {
                this.message = ""
            }
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        IsshowFile(value) {
            this.showFile = value
            console.log(this.showFile)
        },
        changeFileIds(val) {
            this.sendDataInfo.newGoodLicenceAddList[this.eventIndex].uploadVoList = [... this.sendDataInfo.newGoodLicenceAddList[this.eventIndex].uploadVoList, ...val]
            this.showFile = false
        },
        //  打开文件上传组件
        openFile1(val) {
            if (val == 1) {
                this.scanShow = true
            } else {
                this.showFile = true
            }
        },
        // 扫描仪上传
        scanOnSubmit(val) {
            const currentLicence = this.sendDataInfo.newGoodLicenceAddList[this.eventIndex]
            const fileType = currentLicence.lityId

            // 转换文件数据
            const list = val.map(item => ({
                fileUrl: item.fileUrl,
                url: `${this.imgUrl}/${item.fileUrl}`,
                fileName: item.fileName,
                fileId: item.fileId,
                fileType
            }))

            // 确保 uploadVoList 存在
            if (!currentLicence.uploadVoList) {
                currentLicence.uploadVoList = []
            }

            // 添加新文件
            currentLicence.uploadVoList = [...currentLicence.uploadVoList, ...list]
            this.scanShow = false
        },
        setFormatter(key, optionsStr) {
            var opArr = optionsStr ? JSON.parse(optionsStr) : [];
            if (Array.isArray(opArr)) {
                if (opArr.length > 0) {
                    this.sendDataInfo[key] = opArr[0].value;
                    return opArr;
                }
            } else {
                opArr = [];
                return opArr;
            }
        },
        // 下拉赋值
        handleChange(value, name) {
            // value默认参，name当前所需的name
            this.sendDataInfo[name] = value;
        },
        number(e) {
            let flag = new RegExp("^[1-9]([0-9])*$").test(e.target.value);
            if (!flag) {
                this.$message({
                    showClose: true,
                    message: "请输入正整数",
                    type: "warning",
                });
                return;
            }
        },
        //税务名称改变
        taxChange(data) {
            console.log("data", data);
            for (let i = 0; i < this.dictionariesData.swflmc.length; i++) {
                const item = this.dictionariesData.swflmc[i];
                if (item.diName == data) {
                    this.sendDataInfo.taxnumber = item.diCode;
                    break;
                }
            }
        },
        //税务名称改变
        cwflChange(data) {
            for (let i = 0; i < this.dictionariesData.cwfl.length; i++) {
                const item = this.dictionariesData.cwfl[i];
                if (item.diName == data) {
                    this.sendDataInfo.financialCode = item.diCode;
                    break;
                }
            }
        },
        async showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                if (this.dataActionBox.actionType == 4) {
                    let responseData = await this.$http.getPenetrateData({ ids: [this.actionData.orderId] })
                    console.log(responseData);
                    if (responseData.status == 200) {
                        var res = responseData.result
                        // 选中的数据
                        this.$refs.printPlan.openDia(
                            this.actionData.orderId,
                            res.printSource,
                            res.jurId,
                            'oper'
                        );
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: 'error'
                        });
                    }
                } else {
                    // 选中的数据
                    this.$refs.printPlan.openDia(
                        this.actionData.orderId,
                        this.actionData.printSouce,
                        this.actionData.printJurId
                    );
                }
            } else {
                return;
            }
        },
        //证照选择变化
        lityChange(data, index) {
            if (this.ruleData.length == 0) {
                return
            }
            var flag = false
            this.ruleData.forEach(item => {
                if (item.license.indexOf(data) != -1 && !flag) {
                    flag = true
                    this.sendDataInfo.newGoodLicenceAddList[index].glTernumber = this.sendDataInfo[item.field]
                }
            })
            // if (!flag) {
            // this.sendDataInfo.newGoodLicenceAddList[index].glTernumber = ''
            // }
            // this.sendDataInfo.newGoodLicenceAddList[index].glTername = data;
        },
        blurChange(type) {
            if (type == 'bgiRegistno' || type == 'bgiAppnumber' || type == 'bgiProlicense') {
                this.sendDataInfo.newGoodLicenceAddList.forEach((item, index) => {
                    this.lityChange(item.glTername, index)
                })
            }
        },

        //根据赋值字段 清除赋值字段的值
        clear(sField) {
            if (sField) {
                var sField = sField.split(',')
                for (const key in this.sendDataInfo) {
                    sField.forEach(item => {
                        if (key == item) {
                            this.sendDataInfo[key] = ""
                        }
                    })
                }

            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            console.log(sField);
            this.seType = type;
            if (type == 'bgiRegistno' || type == 'bgiBrand') {
                this.instrumentFlag = true;
                this.seTitle = type == 'bgiRegistno' ? '注册证信息' : type == 'bgiBrand' ? '品牌信息' : ''
            } else {
                this.DialogVisible = true;
                this.seId = sId;
                this.seIndex = index;
                this.sField = sField;
            }
            this.parentSearchData.goodType = this.isQixie
        },
        bgiBrandClick(val) {
            if (this.seType == 'bgiBrand') {
                this.sendDataInfo.manufacturer = val.row.manufacturer
                this.sendDataInfo.bgiProlicense = val.row.bgiProlicense
                this.sendDataInfo.bgiBrand = val.row.bgiBrand
            } else {
                this.sendDataInfo.bgiRegistno = val.row.bgiRegistno
            }
            var mx = val.detailsList
            if (this.sendDataInfo.newGoodLicenceAddList.length > 0) {
                this.sendDataInfo.newGoodLicenceAddList.forEach((item, index) => {
                    var arr = mx.filter(val => val.lityId == item.lityId)
                    if (arr.length > 0) {
                        this.sendDataInfo.newGoodLicenceAddList.splice(index, 1)
                    }
                })
            }
            mx.forEach(item => {
                this.sendDataInfo.newGoodLicenceAddList.push({
                    glTername: item.glTername, //证照名称
                    sliTername: "",
                    glTernumber: item.glTernumber,//证照号
                    glReoffice: "",
                    glTervalidity: item.glTervalidity,
                    glRedate: item.glRedate,
                    uploadVoList: item.glUrl, //附件
                    lityId: item.lityId,
                    isIntercept: "1",
                    isUsed: "1",
                    remark: "", //备注
                })
            })
            this.zzList = this.sendDataInfo.newGoodLicenceAddList.map(item => item.lityId)
            this.instrumentFlag = false
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.$set(this.sendDataInfo, item, val[item]);
            });
        },
        changeInputModel(val) {
            console.log("返回", val);
            console.log("返回", this.seType);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == "ggmInitunit") {
                    this.sendDataInfo.ggmInitunit = val.smId;
                    this.sendDataInfo.ggmInitunitName = val.smName;
                } else if (this.seType == "bgmName") {
                    this.sendDataInfo['bgmName'] = val.bgmName
                    this.sendDataInfo['bgmId'] = val.bgmId
                    this.$emit("selectClick", val.bgmId)
                } else {
                    this.paramValue(val);
                }
            }
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },

        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + "/" + item.fileUrl);
            });
            return imgList;
        },

        //获取生产/经营范围
        async getQueryScopeByType(type) {
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByTypeByOrm(params);
            if (responseData.status == 200) {
                return responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取诊疗范围
        async getQueryScopeByTypeZhenLiao(type) {
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByType(params);
            if (responseData.status == 200) {
                return responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        delRemove(index, key) {
            this.eventIndex = index
            this.sendDataInfo.newGoodLicenceAddList[this.eventIndex].uploadVoList.splice(key, 1)
        },
        async fileUpload(files, length, index, e) {
            if (length - 1 >= index) {
                console.log(files[index]);
                const params = {
                    type: 'zz',
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                console.log(response);
                if (response.status == 200) {
                    this.sendDataInfo.newGoodLicenceAddList[this.eventIndex].uploadVoList.push({
                        fileUrl: response.result[0].fileUrl,
                        url: this.imgUrl + "/" + response.result[0].fileUrl,
                        fileName: response.result[0].fileName,
                        fileId: response.result[0].fileId,
                        fileType: this.sendDataInfo.newGoodLicenceAddList[this.eventIndex].lityId,
                    })
                    this.fileUpload(files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        pushDefaultValue(type) {    // 器械表单默认值
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (item.entityField == 'inRate' || item.entityField == 'outRate') {
                    if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
                        this[type][item.entityField] = item.defaultValue;
                    }
                }
            });
        },
        // 默认值
        initDefaultValue(type) {
            let arr = this.formDataList[1].jurconfigform;
            arr.forEach((item) => {
                if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
                    this[type][item.entityField] = item.defaultValue;
                }
            });
            this[type].uploadVoList = [];

            //  this[type].psaiExptime = this.$moment().valueOf();
        },
        //复制一行
        copyClick(row) {
            this.sendDataInfo.newGoodLicenceAddList.push(JSON.parse(JSON.stringify(row)))
        },
        //删除明细
        deleteDetails(row) {
            this.selectedDetailsIndex = this.sendDataInfo.newGoodLicenceAddList.indexOf(row)
            if (this.sendDataInfo.newGoodLicenceAddList.length < 1) {
                this.$message({
                    message: "请先添加",
                    type: "error",
                });
                return false;
            }
            this.sendDataInfo.newGoodLicenceAddList.splice(
                this.selectedDetailsIndex,
                1
            );
            this.zzList = this.sendDataInfo.newGoodLicenceAddList.map(item => {
                return item.lityId
            })
            this.selectedDetailsIndex = 0;
        },
        cancellist(addpushlist) {
            if (this.dataActionBox.boxTitle == "新增") {
                for (const key in this.addpushlist) {
                    this.addpushlist[key] = ""
                }
                this.addpushlist.isIntercept = "1"
                this.addpushlist.isUsed = "1"
                this.addpushlist.uploadVoList = []
            }
            this.dataActionBoxdigion = false;
        },
        // 提交审核
        submitDataAction() {
            this.$confirm("确定要提交审核?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let responseData = await this.$http.addTaskReview(this.taskData);
                    console.log(responseData)
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功",
                        });
                        this.$emit("drawerCancel", true);
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        // 提交审核
        submitData() {
            if (!this.sendDataInfo.ggmId) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = JSON.parse(JSON.stringify(this.sendDataInfo));
            this.$confirm("确定要提交审核吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        businessKey: dataInfo.ggmId,
                    };
                    let responseData = await this.$http.submitFirstGoods(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "操作成功!",
                        });
                        this.$emit("drawerCancel", true);
                        this.$refs["addpushlist"].resetFields();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        initActionBox() {
            this.$emit("drawerCancel");
        },
        init() {
            for (let key in this.sendDataInfo) {
                switch (key) {
                    case "newGoodLicenceAddList": // 证照
                        this.sendDataInfo.newGoodLicenceAddList = [];
                        break;
                    case "descibGoodLicenceAddList": // 证照
                        this.sendDataInfo.descibGoodLicenceAddList = [];
                        break;
                    default:
                    // this.sendDataInfo[key] = "";
                }
            }
        },
        clearSendData(data) {
            for (let key in data) {
                data[key] = "";
            }

            return data;
        },

        async isShowData(name, value) {
            switch (name) {
                case "supplier":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.psomBuycus = dataInfo.smId;
                        this.sendDataInfo.smName = dataInfo.smName;
                    }
                    break;
                case "cargoOwner":
                    var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId;
                        this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName;
                    }
                    break;
            }
        },
        isNull(value) {
            if (value != "" && value != undefined) {
                return true;
            } else {
                return false;
            }
        },
        //获取列表
        openBox() {
            this.getQueryCodeClassifyaArr()
            this.printScanShow = window.global_config.printScanShow ? true : false
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.componentType = this.actionData.fatherType; //父级类型
            this.filterMainField()
            this.dataActionBox.showStatus = true;
            if (this.dataActionBox.actionType == 0) {//器械
                this.showTabs = this.actionData.formData[0].jciName;
                if (this.isQixie === 1) { //器械
                    this.dataActionBox.boxTitle = "器械信息"
                } else if (this.isQixie === 2) { //其他
                    this.dataActionBox.boxTitle = "其他信息"
                } else {
                    this.dataActionBox.boxTitle = "商品信息"
                }
                this.dataActionBox.openMode = "ltr";
                this.actionData.formData[0].jurconfigform.forEach(item => {
                    if (item.entityField == 'codeType' && item.defaultValue != '' && item.defaultValue != null && item.defaultValue != undefined) {
                        this.$nextTick(e => {
                            this.sendDataInfo.codeType = item.defaultValue
                        })
                    }
                })
            } else {
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in this.sendDataInfo) {
                    if (dataInfo[key] || dataInfo[key] === 0) {
                        if (key == 'riskLevel') {
                            this.$set(this.sendDataInfo, key, Number(dataInfo[key]))
                        } else {
                            this.$set(this.sendDataInfo, key, dataInfo[key])
                        }
                        if (key == 'newGoodLicenceAddList') {
                            if (dataInfo[key] != null && dataInfo[key].length > 0) {
                                this.zzList = dataInfo[key].map(item => item.lityId)
                            }
                        }
                    }
                }
                this.$set(this.sendDataInfo, 'bgmId', dataInfo.bgmId)
                if (this.actionData.cate == 1) {
                    var dataInfo1 = JSON.parse(JSON.stringify(this.actionData.oldData1));
                    for (let key in this.sendDataInfoObj) {
                        if (dataInfo1[key] || dataInfo1[key] === 0) {
                            this.$set(this.sendDataInfoObj, key, dataInfo1[key])
                        }
                    }
                    this.$set(this.sendDataInfoObj, 'gchmId', dataInfo1.gchmId)
                }
                this.showTabs = this.actionData.formData[0].jciName;
                if (this.isQixie === 1) { //器械
                    this.dataActionBox.boxTitle = "器械信息"
                } else if (this.isQixie === 2) { //其他
                    this.dataActionBox.boxTitle = "其他信息"
                } else {
                    this.dataActionBox.boxTitle = "商品信息"
                }
                if (this.sendDataInfo.validPeriod != '' && this.sendDataInfo.validPeriod != null) this.sendDataInfo.validPeriod = this.sendDataInfo.validPeriod.split('个月')[0]
                if (this.sendDataInfo.stId != "" && this.sendDataInfo.stId != null) {
                    this.sendDataInfo.stId = Number(this.sendDataInfo.stId)
                }
            }
            if (this.sendDataInfo.bgiType) {
                this.seeTypeChange()
            }
            this.sendDataInfo.bgiProrange = this.sendDataInfo.bgiProrange && this.isNull(this.sendDataInfo.bgiProrange) ? this.sendDataInfo.bgiProrange : ''
            this.sendDataInfo.bgiManrange = this.sendDataInfo.bgiManrange && this.isNull(this.sendDataInfo.bgiManrange) ? this.sendDataInfo.bgiManrange : ''
            this.sendDataInfo.bgiTrerange = this.sendDataInfo.bgiTrerange && this.isNull(this.sendDataInfo.bgiTrerange) ? this.sendDataInfo.bgiTrerange : ''
            this.sendDataInfo.goodType = this.isQixie;   //药品类型0.药品1.器械2.其他

            if (this.isQixie == 1 && this.dataActionBox.actionType == 0) { //器械
                this.pushDefaultValue('sendDataInfo')
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$set(this.sendDataInfo, 'isDl', String(this.sendDataInfo['isDl'] || 0))
                    this.mxHeight = this.$common.getBtnHeight()
                }, 16.7)
            })

        },
        changesmIntype() {
            this.licenseList.forEach(item => {
                this.$set(item, "isBT", 0)
                this.$set(item, "isKX", 0)
            })
            this.rulesList.forEach(item => {
                if (item['商品分类'] == this.sendDataInfo.bgiType) {
                    item['拦截证照'].forEach(items => {
                        var arr = items['证照名称'].split(",")
                        if (arr.length == 1) {
                            var flag = false
                            var flage = false
                            if (this.zzList.length > 0) {
                                this.zzList.forEach(item => {
                                    if (item == arr[0]) {
                                        flage = true
                                    }
                                })
                            }
                            if (!flage) {
                                this.zzList.push(arr[0])
                            }
                            this.licenseList.forEach(item => {
                                if (item.diName == arr[0]) {
                                    this.$set(item, "isBT", 1)
                                }
                            })
                            if (this.sendDataInfo.newGoodLicenceAddList.length > 0) {
                                this.sendDataInfo.newGoodLicenceAddList.forEach(item => {
                                    if (item.glTername == arr[0]) {
                                        flag = true
                                    }
                                })
                            }
                            if (!flag) {
                                this.sendDataInfo.newGoodLicenceAddList.push({
                                    glTername: arr[0], //证照名称
                                    sliTername: "",
                                    glTernumber: "",
                                    glReoffice: "",
                                    glTervalidity: "",
                                    glRedate: "",
                                    uploadVoList: [], //附件
                                    lityId: arr[0],
                                    isIntercept: "1",
                                    isUsed: "1",
                                    remark: "", //备注
                                })
                                var index = this.sendDataInfo.newGoodLicenceAddList.length - 1
                                this.lityChange(arr[0], index)
                            }
                        } else {
                            this.licenseList.forEach(item => {
                                arr.forEach(item1 => {
                                    if (item1 == item.diName) {
                                        this.$set(item, "isKX", 1)
                                    }
                                })
                            })

                        }

                    })
                }
            })
        },
        seeTypeChange() {
            if (this.licenseList) {
                this.licenseList.forEach(item => {
                    this.$set(item, "isBT", 0)
                    this.$set(item, "isKX", 0)
                })
                this.rulesList.forEach(item => {
                    if (item['单位类型'] == this.sendDataInfo.bgiType) {
                        item['拦截证照'].forEach(items => {
                            var arr = items['证照名称'].split(",")
                            if (arr.length == 1) {
                                this.licenseList.forEach(item => {
                                    if (item.diName == arr[0]) {
                                        this.$set(item, "isBT", 1)
                                    }
                                })
                            } else {
                                this.licenseList.forEach(item => {
                                    arr.forEach(item1 => {
                                        if (item1 == item.diName) {
                                            this.$set(item, "isKX", 1)
                                        }
                                    })
                                })

                            }
                        })
                    }
                })
            }
        },
        setzzList() {
            this.$http.getGoodLicenceRule().then(res => {
                this.rulesList = JSON.parse(res.result)
            })
        },
        //保存
        async sendDataAction(formName) {
            this.$refs['dynamicValidateForm'].validate((valid1) => {
                if (valid1) {
                    this.$refs[formName].validate(async (valid) => {
                        if (valid) {
                            this.sendDataInfo.newGoodLicenceAddList.forEach(item => {
                                if (item.glTervalidity == 0) {
                                    item.glTervalidity = ""
                                }
                                if (item.glRedate == 0) {
                                    item.glRedate = ""
                                }
                            })
                            const params = {
                                formId: 11405,
                                descibGoodLicenceList: this.sendDataInfo.newGoodLicenceAddList
                            }
                            params.bgiType = this.sendDataInfo.bgiType
                            var responseData = await this.$http.fromrulecheckGoodsLicense(params)
                            console.log(responseData);

                            if (responseData.status == 200) {
                                if (responseData.result.length > 0) {
                                    this.dialogList = responseData.result
                                    this.showStatus = this.dialogList.findIndex(item => item.level == 0)
                                    this.showDialog = true
                                } else {
                                    this.sub()
                                }
                            } else {
                                this.$message.error(responseData.message)
                            }
                            //   
                        } else {
                            return this.$message({
                                message: "请完善必填商品信息",
                                type: "error",
                            });
                        }
                    });
                } else {
                    return this.$message({
                        message: "请完善必填申请信息",
                        type: "error",
                    });
                }
            })

        },
        showClose() {
            this.showDialog = false
            if (this.showStatus == -1) {
                this.sub()
            }
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), '提示', {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        async sub() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (JSON.stringify(sendData.newGoodLicenceAddList) == JSON.stringify(sendData.descibGoodLicenceAddList)) {
                delete sendData.newGoodLicenceAddList
                delete sendData.descibGoodLicenceAddList
                sendData.descibGoodLicenceAddList = []
                sendData.newGoodLicenceAddList = []
            }
            //else {
            //   sendData.descibGoodLicenceAddList.forEach(item => {//老的
            //      sendData.newGoodLicenceAddList.forEach(item1 => {//新的
            //         for (const key in item) {//老的
            //            for (const key1 in item1) {//新的
            //               if (item[key] === ""&&(item1[key]==null||item1[key]=="")) {//老的
            //                  item1[key] = ""//新的
            //               } else if (item[key] === null&&(item1[key]==null||item1[key]=="")) {//老的
            //                  item1[key] = null//新的
            //               }
            //            }
            //         }
            //      })
            //   })
            //}
            if (this.sendDataInfo.validPeriod && this.sendDataInfo.validPeriod != '') {
                sendData.validPeriod = this.sendDataInfo.validPeriod + '个月';
            } else {
                sendData.validPeriod = ''
            }
            let responseData = ''
            var params = {
                ...this.sendDataInfoObj,
                businessId: this.sendDataInfo.bgmId,
                dempBusgoodmast: sendData,
            };
            if (this.dataActionBox.actionType == 0 || this.dataActionBox.actionType == 3) {
                responseData = await this.$http.gspChangeaddChangeGood(params);
            } else {
                responseData = await this.$http.gspChangeupdateChangeInfo(params);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", true);
                this.$refs["addpushlist"].resetFields();
            } else if (responseData.status == 300) {
                this.$confirm(responseData.message + ", 是否继续新增?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(async () => {
                        this.sendDataInfo.state = 0
                        this.sub()
                    })
                    .catch(() => {
                        this.sendDataInfo.state = ''
                    });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取字典数据
        getPartDictionariesData() {
            this.$http.getPartDictionariesData({
                ids: [14, 10, 9, 25, 11, 13, 5, 30, 39, 41, 42, 43, 58, 61, 70, 71],
            }).then(responseData => {
                if (responseData.status == 200) {
                    this.dictionariesData = responseData.result;
                    // 药品类型0.药品1.器械2.其他
                    if (/(器)/g.test(this.showTabs)) {
                        this.licenseList = this.dictionariesData.QXZZLX
                    } else if (/(其他)/g.test(this.showTabs)) {
                        this.licenseList = this.dictionariesData.QTZZLX
                    } else {
                        this.licenseList = this.dictionariesData.spzzlx
                    }
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            })
        },

        // 获取所有可用库房列表
        getAllStorageRoom() {
            this.$http.getGspStorageRoom().then(responseData => {
                if (responseData.status == 200) {
                    this.storageRoomList = responseData.result;
                    if (this.storageRoomList.length != 0 && this.dataActionBox.actionType == 0) {
                        //赋个默认值,defaultValue的值过滤 可用库房列表 
                        this.tabForm[0].jurconfigform.forEach(item => {
                            if (item.entityField == 'stId') {
                                if (item.defaultValue !== "" && item.defaultValue != null) {
                                    let isGiveValue = false
                                    this.storageRoomList.forEach(e => {
                                        if (e.stName == item.defaultValue) {
                                            this.sendDataInfo.stId = e.stId
                                            isGiveValue = true
                                        }
                                    })
                                    if (!isGiveValue) {
                                        this.sendDataInfo.stId = this.storageRoomList[0].stId
                                    }
                                } else {
                                    this.sendDataInfo.stId = this.storageRoomList[0].stId
                                }
                            }
                        })
                    }
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            });

        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) {
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                    }
                    if (key.jurconfigform[index].entityField == 'stId' && key.jurconfigform[index].isShow == 0) {
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                    }
                }
            });
            var arr = [{ entityField: "newGoodLicenceAddList" }, { entityField: "descibGoodLicenceAddList" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            mainFormList[1].jurconfigform.forEach(item => {
                if (item.fieldType == 'number') {
                    this.$set(this.addpushlist, item.entityField, 0)
                } else if (item.fieldType == 'search' && item.setField) {
                    var arr = item.setField.split(',')
                    arr.forEach(item2 => {
                        this.$set(this.addpushlist, item2, "")
                    })
                } else {
                    this.$set(this.addpushlist, item.entityField, "")
                }
            })
            const list = new Set()
            this.tabForm.forEach(item => {
                list.add(item.jciId)
            })
            const result = []
            Array.from(list).forEach(items => {
                result.push(this.tabForm[this.tabForm.findIndex(item => item.jciId == items)])
            })
            this.tabForm = result
        },
        async getQueryCodeClassifyaArr() {
            let params = { "codeClassify": 0 } // "编号分类0.商品1.供应商2.客户")
            let res = await this.$http.getQueryCodeClassify(params)
            this.codeClassify = res.result
        },
        // 获取申请人员信息
        initDep() {
            let info = JSON.parse(sessionStorage.getItem('userInfo'))
            this.sendDataInfoObj.depName = info.depName
            this.sendDataInfoObj.depId = info.depId
            this.sendDataInfoObj.opmName = info.opmName
            this.sendDataInfoObj.opmId = info.opmId
            this.sendDataInfoObj.gchmType = 0
        },
        getGoodType() {
            const tabs = this.showTabs || '';
            if (/(其他)/g.test(tabs)) return 2;
            if (/(器)/g.test(tabs)) return 1;
            return 0;
        },
        async ruleChange() {
            const res = await this.$http.getLicenceNumberRule()
            if (res.status == 200) {
                if (res.result.ruleParam && res.result.isEnable == 1) {
                    this.ruleData = JSON.parse(res.result.ruleParam)
                } else {
                    this.ruleData = []
                }
            } else {
                this.$message.error(res.message)
            }
        },
        openBoxS() {
            this.showTabs = this.actionData.formData[0].jciName;
            this.isQixie = this.getGoodType();
            this.initDep()
            this.getPartDictionariesData();
            this.setzzList()
            this.ruleChange()
            this.imgur();
            this.$nextTick(() => {
                this.openBox();
                this.getAllStorageRoom();
                this.isLoaded = true;
                //type 范围类型0.生产范围1.经营范围
                this.getQueryScopeByType(0).then((res) => {
                    this.$set(this.rangeObj, "p", res);
                });
                this.getQueryScopeByType(1).then((res) => {
                    this.$set(this.rangeObj, "m", res);
                });
                this.getQueryScopeByTypeZhenLiao(2).then((res) => {
                    this.$set(this.rangeObj, "z", res);
                });

            });

        }
    },

    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.openBoxS()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 450px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.oldInput {
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 28px;
    line-height: 28px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 90%;
}

.oldDisabled {
    background-color: #f5f7fa;
}

#bgmRemarks {
    width: 100%;
}

#bgmRemarks ::v-deep .el-form-item__content {
    width: 80% !important;
}

#bgmRemarks ::v-deep .el-textarea__inner {
    width: 76% !important;
}

::v-deep .upload-demo ul {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
}

::v-deep .upload-demo img {
    width: 30px;
    height: 30px;
    margin-left: 0px;
}

::v-deep .upload-demo .el-upload-list--picture .el-upload-list__item {
    width: 86px;
    height: 42px;
    padding: 5px 0px;
    padding-left: 5px;
}

::v-deep .el-upload-list__item-name {
    margin-right: 0;
    font-size: 13px;
}

::v-deep .el-upload-list__item .el-icon-close {
    top: 2px;
    right: 2px;
}

::v-deep .el-upload-list--picture .el-upload-list__item-status-label {
    width: 40px;
    height: 24px;
    right: -20px;
    top: -9px;
}

::v-deep
    .el-upload-list--picture
    .el-upload-list__item.is-success
    .el-upload-list__item-name {
    line-height: 30px;
}

::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
    color: #333;
}

::v-deep
    .el-radio-button__orig-radio:disabled:checked
    + .el-radio-button__inner {
    background-color: #ccc;
}

::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
    color: #333;
}

.view-warp {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
}

/* 全局 */
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 10px;
}

/* 视频预览 */
#view1,
#view2 {
    /* width: 400px; */
    height: 300px;
    border: 1px solid #000;
    margin-right: 5px;
}

/* 缩略图 */
#suoluetu {
    /* width: 100%; */
    /* height: 85px; */
    flex: 1;
    height: 300px;
    /* border: 1px solid #ccc; */
}

#suoluetu img {
    width: 100%;
    height: 300px;
    margin-right: 10px;
}

/* 操作按钮 */
#myactive {
    /* border: 1px solid yellowgreen; */
    margin-top: 10px;
    padding: 10px 5px;
}

/* 操作日志 */
#mylog {
    border: 1px solid black;
    padding: 10px;
    margin-top: 10px;
    overflow: auto;
}

.baseForm ::v-deep .el-form-item__content {
    margin-left: 124px !important;
}

.baseForm ::v-deep .el-form-item__label {
    width: 124px !important;
}

.xing {
    position: absolute;
    top: 0;
    left: 5px;
    font-size: 18px;
    font-weight: 800;
}

/* 图片上传样式 */
.uploadList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 220px;
    list-style: none;
}

.image {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
    margin-right: 0;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.image:hover .del {
    display: inline-block;
}

.image_label {
    cursor: pointer;
    padding: 7px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}

::v-deep .el-image__error {
    font-size: 7px;
}
</style>